import React, { createContext, useContext, useMemo } from 'react';
const SideBarContext = /*#__PURE__*/createContext(null);
export function SideBarProvider({
  expandStatus,
  toggleExpand,
  topSectionRef,
  children
}) {
  const contextValue = useMemo(() => ({
    expandStatus,
    toggleExpand,
    topSectionRef
  }), [expandStatus, toggleExpand, topSectionRef]);
  return /*#__PURE__*/React.createElement(SideBarContext.Provider, {
    value: contextValue
  }, children);
}
export function useSideBar() {
  const context = useContext(SideBarContext);

  if (!context) {
    throw new Error('useSideBar must be used from inside a <SideBar />');
  }

  return context;
}